export var USABILLA_BUTTON_ID = '14df9973d41a';
export var USABILLA_COOKIE = 'usabillaAlreadyShown';
export var USABILLA_COOKIE_EXPIRATION_TIME_MS = 24 * 60 * 60 * 1000;
